import { get, type Readable, writable } from "svelte/store"

export function asyncDerived<T, U>(store : Readable<U>, fn : (val : U, current? : T) => Promise<T>, def : T) : Readable<T> {
    let i = 0
    const {subscribe, set} = writable<T>(def)

    store.subscribe((val) => {
        i++
        const currentI = i
        fn(val, get({subscribe})).then((res) => {
            if (currentI !== i) return // Canceleable
            set(res)
        })
    })

    return {
        subscribe
    }
}